import ComponentWithSocket from '../../../lib/component';
import {Component} from 'vue-property-decorator';

@Component
export default class AuctionsAdd extends ComponentWithSocket {
    public addCertificate: {
        existingLot: boolean;
        auction: any;
        lot: any;
        salesDate: string;
        releaseDate: string;
        firstName: string;
        lastName: string;
        lotId: string;
        lotImage: any;
        lotName: string;
        lotTechnical: string;
        lotSize: string;
        lotTechnicalDetails: string;
    } = {
        existingLot: true,
        auction: {
            selected: undefined as any,
            isLoading: false
        },
        lot: {
            selected: undefined as any,
            isLoading: false
        },
        salesDate: '',
        releaseDate: '',
        firstName: '',
        lastName: '',
        lotId: '',
        lotImage: '',
        lotName: '',
        lotTechnical: '',
        lotSize: '',
        lotTechnicalDetails: ''
    };

    public auctions: any[] = [];
    public lots: any[] = [];
    public addBtnLoading: boolean = false;
    public addCertificateSuccess: string = '';
    public addCertificateError: string = '';

    constructor() {
        super();
    }

    mounted() {
        this.getAuctions();
    }

    async getAuctions() {
        this.addCertificate.auction.isLoading = true;

        await fetch(`${process.env.API2_URL}/auction`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.addCertificate.auction.isLoading = false;
                this.auctions = data.data;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async getLots() {
        this.addCertificate.lot.selected = undefined as any;
        this.addCertificate.lot.isLoading = true;

        await fetch(`${process.env.API2_URL}/lot?auction=${this.addCertificate.auction.selected.value}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.addCertificate.lot.isLoading = false;
                this.lots = data.data;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async addCertificateAction() {
        let payload = {};
        let lotImage: any = '';

        if (this.addCertificate.existingLot) {
            if (!this.addCertificate.auction.selected || !this.addCertificate.lot.selected || !this.addCertificate.firstName || !this.addCertificate.lastName || !this.addCertificate.salesDate || !this.addCertificate.releaseDate) {
                alert('Te rugam sa completezi toate datele din formular');
                return;
            }

            payload = {
                'existing_lot': true,
                'first_name': this.addCertificate.firstName,
                'last_name': this.addCertificate.lastName,
                'sales_date': this.addCertificate.salesDate,
                'release_date': this.addCertificate.releaseDate,
                'lot_id': this.addCertificate.lot.selected.value
            }
        } else {
            if (!this.addCertificate.lotName || !this.addCertificate.lotTechnical || !this.addCertificate.lotSize || !this.addCertificate.lotTechnicalDetails || !this.addCertificate.firstName || !this.addCertificate.lastName || !this.addCertificate.salesDate || !this.addCertificate.releaseDate) {
                alert('Te rugam sa completezi toate datele din formular');
                return;
            }

            if (this.addCertificate.lotImage) {
                lotImage = await this.convertToBase64(this.addCertificate.lotImage);
            }

            payload = {
                'existing_lot': false,
                'first_name': this.addCertificate.firstName,
                'last_name': this.addCertificate.lastName,
                'sales_date': this.addCertificate.salesDate,
                'release_date': this.addCertificate.releaseDate,
                'lot_image': lotImage,
                'lot': {
                    'name': this.addCertificate.lotName,
                    'technical': this.addCertificate.lotTechnical,
                    'size': this.addCertificate.lotSize,
                    'technical_details': this.addCertificate.lotTechnicalDetails,
                }
            }
        }

        this.addBtnLoading = true;

        await fetch(`${process.env.API2_URL}/certificate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
                this.addCertificateError = `Eroare: ${response.status}`;
                this.addCertificateSuccess = '';
            }

            this.addBtnLoading = false;

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.addCertificateSuccess = data.message;
                this.addCertificateError = '';
                this.addCertificate.existingLot = true;
                this.addCertificate.auction.selected = undefined;
                this.addCertificate.lot.selected = undefined;
                this.addCertificate.salesDate = '';
                this.addCertificate.releaseDate = '';
                this.addCertificate.firstName = '';
                this.addCertificate.lastName = '';
                this.addCertificate.lotId = '';
                this.addCertificate.lotImage = '';
                this.addCertificate.lotName = '';
                this.addCertificate.lotTechnical = '';
                this.addCertificate.lotSize = '';
                this.addCertificate.lotTechnicalDetails = '';
            } else {
                this.addCertificateError = data.message;
                this.addCertificateSuccess = '';
            }

            this.addBtnLoading = false;
        }).catch(error => {
            console.error('Error:', error);
            this.addCertificateError = error;
            this.addCertificateSuccess = '';
            this.addBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/certificates/add/index.ts